var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgComment(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 22,
    height: 19.5,
    viewBox: "0 0 24.323 19.5",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "chat",
    transform: "translate(0 -50.758)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3121",
    transform: "translate(0 50.758)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3120"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1258",
    d: "M17.686 50.758H1.37A1.371 1.371 0 0 0 0 52.128v9.789a1.371 1.371 0 0 0 1.37 1.37h1.058v3.643a.574.574 0 0 0 .98.406l4.05-4.05h.813a.574.574 0 0 0 0-1.148H7.182a.571.571 0 0 0-.367.166l-3.24 3.241v-2.884A.574.574 0 0 0 3 62.138H1.37a.222.222 0 0 1-.222-.222v-9.788a.222.222 0 0 1 .222-.222h16.316a.222.222 0 0 1 .222.222v3.755a.574.574 0 1 0 1.148 0v-3.755a1.371 1.371 0 0 0-1.37-1.37z",
    className: "cls-1",
    transform: "translate(0 -50.758)"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_3123",
    transform: "translate(10.162 57.776)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3122"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1259",
    d: "M226.714 198.492h-11.421a1.371 1.371 0 0 0-1.37 1.37v6.678a1.371 1.371 0 0 0 1.37 1.37h7.15l2.9 2.9a.574.574 0 0 0 .98-.406v-2.491h.394a1.371 1.371 0 0 0 1.37-1.37v-6.678a1.371 1.371 0 0 0-1.373-1.373zm.222 8.047a.222.222 0 0 1-.222.222h-.968a.573.573 0 0 0-.572.53v1.724l-2.083-2.083-.007-.006-.023-.021a.571.571 0 0 0-.378-.143h-7.388a.222.222 0 0 1-.222-.222v-6.678a.222.222 0 0 1 .222-.222h11.421a.222.222 0 0 1 .222.222z",
    className: "cls-1",
    transform: "translate(-213.923 -198.492)"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_3125",
    transform: "translate(16.669 61.911)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3124"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1260",
    d: "M351.46 285.53a.574.574 0 1 0 .574.574.574.574 0 0 0-.574-.574z",
    className: "cls-1",
    transform: "translate(-350.886 -285.53)"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_3127",
    transform: "translate(3.733 54.551)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3126"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1261",
    d: "M89.588 130.611H79.146a.574.574 0 0 0 0 1.148h10.442a.574.574 0 0 0 0-1.148z",
    className: "cls-1",
    transform: "translate(-78.572 -130.611)"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_3129",
    transform: "translate(3.733 58.345)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3128"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1262",
    d: "M83.109 210.465h-3.963a.574.574 0 1 0 0 1.148h3.963a.574.574 0 1 0 0-1.148z",
    className: "cls-1",
    transform: "translate(-78.572 -210.465)"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_3131",
    transform: "translate(14.002 61.911)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3130"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1263",
    d: "M295.333 285.53a.574.574 0 1 0 .574.574.574.574 0 0 0-.574-.574z",
    className: "cls-1",
    transform: "translate(-294.759 -285.53)"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_3133",
    transform: "translate(19.335 61.911)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3132"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1264",
    d: "M407.575 285.53a.574.574 0 1 0 .574.574.574.574 0 0 0-.574-.574z",
    className: "cls-1",
    transform: "translate(-407.001 -285.53)"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgComment);
export default __webpack_public_path__ + "static/media/Comment.3ba7a56854e70211329e5ba2320aa411.svg";
export { ForwardRef as ReactComponent };